import { Injectable, inject } from '@angular/core';
import { ContentHeaderAction, ContentHeaderProps } from '@b2b/types/core';

import { PermissionsService } from '../permissions/permissions.service';

@Injectable({ providedIn: 'root' })
export class ContentHeaderService {
  private readonly permissionsService = inject(PermissionsService);

  title: string | false = false;
  buttonLeft: ContentHeaderProps['buttonLeft'];
  buttonRight: ContentHeaderProps['buttonRight'];
  isLoading = false;

  init(): boolean {
    return true;
  }

  update(props: ContentHeaderProps): void {
    this.title = props.title ? props.title : false;
    this.buttonLeft = this.getContentHeaderAction(props.buttonLeft);
    this.buttonRight = this.getContentHeaderAction(props.buttonRight);
  }

  private getContentHeaderAction(action?: ContentHeaderAction): ContentHeaderAction | undefined {
    if (action == null) {
      return undefined;
    }

    if (action.permissions) {
      return this.permissionsService.check(action.permissions) ? action : undefined;
    }

    return action;
  }
}
